import React from "react";
import { ENVIRONMENT } from "../scripts/constants";
import { authenticationService } from "../scripts/authentication.service";
import Header from "../header/header";
import {withSnackbar} from "notistack";
import {cf} from "../scripts/custom-fetch";

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            env: ENVIRONMENT,
            currentUser: authenticationService.currentUserValue,
            settings: {
                id: 1,
                christmas: 0,
                easter: 0,
                halloween: 0,
                newyear: 0,
                online: 1,
            }
        };
    }

    getSettings = () => {
        const options = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json'},
        };

        cf.get(`${process.env.REACT_APP_API_GET}/settings`, options)
            .then(result => {
                this.setState({
                    settings: result.settings
                })
            })
    }

    componentDidMount() {
        this.getSettings()
    }

    render() {
        const { env, currentUser, settings } = this.state;
        return (
            <>
                <Header />

                {!!settings.christmas && (
                    <div className="main-tree">
                        <div className="home-text">
                            <p>
                                {(env === "dev" && !currentUser.perms.dev) ? "For Developers ONLY Keep Out!" : "Welcome To Dev Social"}
                                {env === "staging" && "Welcome To Staging Social"}
                                {env === "live" && "Welcome To Live Social"}
                            </p>
                            <p>Hi {currentUser.username}{currentUser.username === "georgia" && "! Have you come to break my toys?"}</p>
                        </div>
                        <div className="tree-wrap">

                            <div className="star"></div>

                            <ul className="tree">
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                            </ul>
                            <ul className="tree middle">
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                            </ul>
                            <ul className="tree bottom">
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                            </ul>

                            <ul className="lightrope">
                                <li style={{top:"40.8%", left:"36%"}}></li>
                                <li style={{top:"41.3%", left:"42%"}}></li>
                                <li style={{top:"40.6%", left:"48%"}}></li>
                                <li style={{top:"38.5%", left:"54%"}}></li>
                                <li style={{top:"55.5%", left:"28%"}}></li>
                                <li style={{top:"56%", left:"34%"}}></li>
                                <li style={{top:"56.2%", left:"40%"}}></li>
                                <li style={{top:"55.5%", left:"46%"}}></li>
                                <li style={{top:"53.9%", left:"52%"}}></li>
                                <li style={{top:"51.3%", left:"58%"}}></li>
                                <li style={{top:"49.1%", left:"62%"}}></li>
                                <li style={{top:"72%", left:"24%"}}></li>
                                <li style={{top:"72.6%", left:"30%"}}></li>
                                <li style={{top:"72.8%", left:"36%"}}></li>
                                <li style={{top:"72.7%", left:"42%"}}></li>
                                <li style={{top:"72%", left:"48%"}}></li>
                                <li style={{top:"70.8%", left:"54%"}}></li>
                                <li style={{top:"68.8%", left:"60%"}}></li>
                                <li style={{top:"65.2%", left:"66%"}}></li>
                            </ul>
                        </div>
                        <div className="ground"></div>
                    </div>
                )}

                {!settings.christmas && !!settings.halloween && (
                    <div className="main-spooky">
                        <div className="home-text spooky-text">
                            <p>
                                {(env === "dev" && !currentUser.perms.dev) ? "For Developers ONLY Keep Out!" : "Welcome To Dev Social"}
                                {env === "staging" && "Welcome To Staging Social"}
                                {env === "live" && "Welcome To Live Social"}
                            </p>
                            <p>Hi {currentUser.username}... Boo!</p>
                        </div>

                        <div className="moon"></div>

                        <div className="bat bat-1"></div>
                        <div className="bat bat-2"></div>
                        <div className="bat bat-3"></div>

                        <div className="spider"><div className="spider-body"></div></div>

                        <div className="ghost">
                            <div className="ghost-eye left"></div>
                            <div className="ghost-eye right"></div>
                        </div>

                        <div className="graveyard">
                            <div className="tombstone">RIP</div>
                            <div className="tombstone small"></div>
                        </div>

                        <div className="pumpkin">
                            <div className="pumpkin-stem"></div>
                            <div className="pumpkin-eye left"></div>
                            <div className="pumpkin-eye right"></div>
                            <div className="pumpkin-mouth"></div>
                        </div>

                        <div className="spooky-ground"></div>
                    </div>
                )}

                {!settings.christmas && !settings.halloween && (
                    <div className="home-text-normal">
                        <p>
                            {(env === "dev" && !currentUser.perms.dev) ? "For Developers ONLY Keep Out!" : "Welcome To Dev Social"}
                            {env === "staging" && "Welcome To Staging Social"}
                            {env === "live" && "Welcome To Live Social"}
                        </p>
                        <p>Hi {currentUser.username}</p>
                    </div>
                )}

                <div style={{
                    background: "#0000003b",
                    marginTop: "30px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    padding: "10px",
                    boxShadow: "#00000054 2px 2px 1px 0px",
                }}>
                    <div>Latest Changes</div>
                    <ul style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        marginLeft: "50px",
                        fontSize: "25px",
                    }}>
                        <li>New Personas</li>
                        <li>Youtube</li>
                        <li>Twitch</li>
                    </ul>
                </div>
            </>
        );
    }
}

export default withSnackbar(Home);
